import { isNullish } from 'helpers/misc';

export function getRowIdFromEvent(e: {
  currentTarget: EventTarget | null;
}): string | number | undefined {
  const el = e.currentTarget as HTMLElement | null;
  const attr = el?.getAttribute('data-id');
  if (isNullish(attr)) return undefined;

  const numericId = Number(attr);
  return Number.isFinite(numericId) ? numericId : attr;
}

export function getRowFromEvent<T>(
  e: { currentTarget: EventTarget | null },
  rows: T[],
  getRowId: (row: T) => string | number
): T | undefined {
  const id = getRowIdFromEvent(e);
  if (isNullish(id)) return undefined;

  return rows.find((r) => getRowId(r) === id);
}
